export default [
  {
    path: '/voice-by-sangat/list',
    name: 'voice-by-sangat-list',
    component: () => import('@/views/voice-by-sangat/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Voice by sangat',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Voice by sangat', active: true }],
      permissions: ['video_list']
    }
  }
]
